import React from 'react';
import { ExpandableMenuProps } from 'src/app/molecules/Header/Header/HeaderLinks';
import MegaMenu from 'molecules/Header/MegaMenu/MegaMenuContainer';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import ProductsMegaMenuFeatures from './ProductsMegaMenuFeatures';
import ProductsMegaMenuLearnMore from './ProductsMegaMenuLearnMore';

const ProductsMegaMenu = ({ isOpen, onClose }: ExpandableMenuProps): JSX.Element => {
  return (
    <MegaMenu
      isOpen={isOpen}
      onClose={onClose}
    >
      <Stack
        margin={['spacing-none', 'spacing-auto']}
        align='stretch'
        justify='space-between'
        direction='row'
        maxWidth='width-3xl'
        padding={['spacing-none', 'spacing-4xl']}
      >
        <ProductsMegaMenuFeatures />
        <ProductsMegaMenuLearnMore />
      </Stack>
    </MegaMenu>
  );
};

export default ProductsMegaMenu;
